import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import { ReactSortable } from "react-sortablejs";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { processResponse, processItemResponse } from '../../../../../utilities/processResponse';
import { getQuestionList } from '../../../../../actions/SurveyAction';

class RankItemGroupResponse extends Component {
  constructor(props) {
    super(props);
        this.state = {
            unRankedList:[],
            rankedList: [],
            simpleRankList:[],
            newRankedList:[],
            isDrag:false,
            isSelect:false
        };

        this.reviewPage = this.props.questionItemList || [];
        this.rankedList = [];
        this.tempRankedList = [];
    }

    componentWillMount() {
        const { scaleResponses } = this.props;

        this.setState({
            unRankedList:scaleResponses.scaleResponses,
            simpleRankList:scaleResponses.scaleResponses,
        });
    }

    componentWillReceiveProps(nextProps) {
        const { getAllItemResponse, items, configuration, ratees, getAllItemResponseForMultiple, rateeKey, putAllForItemCollection, scaleResponses } = nextProps;
        const { itemResponseSets } = getAllItemResponse;

        for (const key in getAllItemResponseForMultiple) {
            this.isUpdateResponse = true;

            items.isHide = false;
            if (Object.hasOwnProperty.call(getAllItemResponseForMultiple, key)) {
                const elementRes = getAllItemResponseForMultiple[key];

                if (rateeKey !== undefined && key === rateeKey) {
                    const { itemResponseSets } = elementRes;
                    for (const key in itemResponseSets) {
                        if (itemResponseSets.hasOwnProperty(key)) {
                            const element = itemResponseSets[key];
                            const tempItemResponseSets = itemResponseSets[key];
                            const scaleResponseTemp = scaleResponses.scaleResponses;

                            if (element.itemKey.toLowerCase() === items.key.toLowerCase()) {
                                this.reviewPage[items.key][0].userResponse = element.itemResponses;
                                var itemResponsesObj = element.itemResponses.length >=2 ? element.itemResponses : element.demographicResponses.length > 0 ? element.demographicResponses : [] //// old code

                                itemResponsesObj.forEach(item => {
                                    for (const key in scaleResponseTemp) {
                                        if (scaleResponseTemp.hasOwnProperty(key)) {
                                            const scaleResponses = scaleResponseTemp[key];
                                            if (parseInt(scaleResponses.response) === parseInt(item.response)){
                                                item.responseDescription = scaleResponses.responseDescription;
                                            }
                                        }
                                    }

                                    if (this.state.isSelect === false) {

                                        this.setState({
                                            isSelect:true,
                                            rankedList:itemResponsesObj,
                                            simpleRankList:itemResponsesObj
                                        });
                                        var unRankedListTemp = this.state.unRankedList;

                                        var selectedRows= unRankedListTemp.filter(function(cv){
                                            return !itemResponsesObj.find(function(e){
                                                return parseInt(e.response) == parseInt(cv.response);
                                            });
                                        });
                                        this.setState({unRankedList:selectedRows});
                                    }
                                });

                                for (const key in tempItemResponseSets.itemResponses) {
                                    if (tempItemResponseSets.itemResponses.hasOwnProperty(key)) {
                                        const temp = tempItemResponseSets.itemResponses[key];
                                        const itemList = this.reviewPage[items.reviewPageKey];
                                        for (const key in itemList) {
                                            if (itemList.hasOwnProperty(key)) {
                                                const itemRes = itemList[key];
                                                var itemResponseArr = tempItemResponseSets.itemResponses.length > 0 ? tempItemResponseSets.itemResponses : tempItemResponseSets.demographicResponses.length > 0 ? tempItemResponseSets.demographicResponses: [];

                                                if (this.state.isSelect === false) {
                                                    itemRes.isAnswer = temp.responseValue !== null ? true : false;
                                                    itemRes.isRequired = false;
                                                    itemRes.itemResponses[tempItemResponseSets.itemKey] = itemResponseArr;
                                                    var itemType = configuration.itemType;
                                                    var responseSet = this.props.itemResponses[tempItemResponseSets.itemKey] = {};

                                                    processItemResponse(tempItemResponseSets.itemKey, responseSet, tempItemResponseSets.itemResponses, itemType, rateeKey, putAllForItemCollection,"onLoad");
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

//new Added code
    handleResponse = (newState) => {
        try {
            const { configuration, items } = this.props;
            const { minSelections, maxSelections } = configuration.itemTypeProperties;
            var rankedElement = document.getElementById(`_Ranked_${configuration.key}`);

            const filteredArr = newState.reduce((acc, current, index) => {
                const x = acc.find(item => item.response === current.response);

                if (!x) {
                    current.responseValue = index + 1;
                    return acc.concat([current]);
                } else {
                    return acc;
                }
            }, []);

            var minSelectionsTemp = parseInt(minSelections) || 0;
            var maxSelectionsTemp = parseInt(maxSelections) || 0;
            var itemCount = this.rankedList.length;

            if (filteredArr.length <= minSelectionsTemp || filteredArr.length <= maxSelectionsTemp) {
                this.setState({rankedList:filteredArr});
                this.rankedList = filteredArr;

            } else {
                for (var i = 0, len = this.state.unRankedList.length; i < len; i++) {
                    var ItemIndex = filteredArr.filter(b => b.response === this.state.unRankedList[i].response);
                    this.setState({unRankedList:this.state.unRankedList.concat(ItemIndex)});
                }
            }

            if (itemCount >= minSelectionsTemp && itemCount <= maxSelectionsTemp && rankedElement) {
                rankedElement.style = 'border:1px solid #009688';
                this.handleRankItem(null);

            } else if (itemCount === 0 && rankedElement) {
                rankedElement.style = '1px solid rgba(0,0,0,.125)';

            } else if (rankedElement) {
                rankedElement.style = 'border:1px solid red';
            }

        } catch (error) {
            console.log("Exception: while dragging left to right:_", error.message)
        }
    }

    /**
     * Single select ranked item
     *
     * @param {*} newState
     */
    handleSimpleList = (newState) => {

        const filteredArr = newState.reduce((acc, current, index) => {
            const x = acc.find(item => item.response === current.response);

            if (!x) {
                current.responseValue = index + 1;

                return acc.concat([current]);
            } else {
                return acc;
            }

        }, []);

        for (const key in filteredArr) {
            if (Object.hasOwnProperty.call(filteredArr, key)) {
                const element = filteredArr[key];
                var resValue = element.responseValue;
                element.sequence = resValue.toString();
            }
        }

        this.setState({simpleRankList:filteredArr});
        this.handleRankItem(null, filteredArr);

        this.rankedList = [...filteredArr];
    }

    handleRankItem = (itemCount, filteredArr) => {
        try {
            const { items, handleItemResponse, configuration, rateeKey, ratees, putAllForItemCollection } = this.props;

            /* Manage the question answer response */
            for (const key in this.reviewPage[items.reviewPageKey]) {
                if (this.reviewPage.hasOwnProperty(items.reviewPageKey)) {
                    const itemList = this.reviewPage[items.reviewPageKey];
                    var itemKey = itemList[key].key;

                    if (itemList[key].key.toLowerCase() === items.key.toLowerCase()) {
                        for (const rKey in ratees) {

                            if (ratees.hasOwnProperty(rKey)) {
                                const tempRatees = ratees[rKey];

                                if (tempRatees.dataCollectionGuid === rateeKey) {
                                    itemList[key].isAnswer = itemCount !== 0 ? true : false;
                                    itemList[key].isRequired = itemCount !== 0 ? false : true;;

                                    var tempObj = [];

                                    filteredArr.map((item) => {
                                        tempObj.push({
                                            "itemType"     : configuration.itemType,
                                            "buttonGroup"  : null,
                                            "sequence"     : 1,
                                            "isNa"         : itemList[key].isNA,
                                            "response"     : item.response,
                                            "responseValue": item.responseValue,
                                            "openEnd"      : null,
                                            "responseDescription":item.responseDescription
                                        });
                                    });


                                    itemList[key].itemResponses[itemKey] = tempObj;

                                    itemList[key].userResponse = tempObj;

                                    itemList[key].userResponse.filter((item) => {
                                        if (item.response === configuration.response) {
                                            itemList[key].userResponse.splice(itemList[key].userResponse.indexOf(item), 1);
                                        }
                                        return true;
                                    });

                                    var responseSet = this.props.itemTempResponses[itemKey] = {};
                                    var itemResponses = itemList[key].itemResponses[itemKey];
                                    var itemType = configuration.itemType;

                                    itemResponses = tempObj;

                                    for (const key in itemResponses) {
                                        if (Object.hasOwnProperty.call(itemResponses, key)) {
                                            const element = itemResponses[key];
                                            element.sequence = parseInt(element.responseValue)
                                        }
                                    }
                                    processItemResponse(itemKey, responseSet, itemResponses, itemType, rateeKey, putAllForItemCollection,"onChange");
                                }
                            }
                        }
                    } else {
                        if (itemList[key].isAnswer !== true) itemList[key].isAnswer = false;
                    }
                    this.setState({itemResponses:itemList[key].itemResponses[itemList[key].key]});
                }
            }

             if (this.state.isDrag) {
                this.setState({isDrag:false, isSelect:true});
                handleItemResponse(items.key, this.props.itemTempResponses,putAllForItemCollection, "itemChange", rateeKey);
             }

        } catch (error) {
            console.log("Exception: while responding question answer in ranked response:_", error);
        }
    }

    removeItem = (id) => {
        try {
            const { configuration } = this.props;
            const { minSelections, maxSelections } = configuration.itemTypeProperties;
            var rankedElement = document.getElementById(`_Ranked_${configuration.key}`);

            var minSelectionsTemp = parseInt(minSelections);
            var maxSelectionsTemp = parseInt(maxSelections);
            const data = this.state.rankedList;

            data.filter((item) => {
                if (item.response === id) {
                    var index = data.indexOf(item);
                    if (index !== -1) {
                        data.splice(index, 1);
                        this.setState({rankedList:data});
                    }

                    this.setState({unRankedList:this.state.unRankedList.concat(item)});
                }
            });


            var itemCount = data.length || 0;

            if (itemCount >= minSelectionsTemp && itemCount <= maxSelectionsTemp) {
                rankedElement.style = 'border:1px solid #009688';
                this.handleRankItem(itemCount);

            } else if (itemCount === 0) {
                rankedElement.style = '1px solid rgba(0,0,0,.125)';
                this.handleRankItem(itemCount);

            } else {
                rankedElement.style = 'border:1px solid red';
            }

        } catch (error) {
            console.log("Exception: while removing item from unRanked list:_", error.message)
        }
    }



    handleDrag = () => {
        const {putAllForItemCollection} = this.props
        const putAll = putAllForItemCollection;
        this.setState({isDrag:true});
    }

  render() {
    const { unRankedList, rankedList, simpleRankList } = this.state;
    const { configuration, key } = this.props;
    const { className } = configuration;
    const { minSelections, maxSelections } = configuration.itemTypeProperties;

    return (
    <Fragment>
      <Row>
        {minSelections && maxSelections ? <><Col md="6">
        {configuration.scalePreSection !== null ? <div dangerouslySetInnerHTML={{__html:processResponse(configuration.scalePreSection)}}></div>:null}
            <ReactSortable
                className={`_Ranked_${className}`}
                list={unRankedList}
                setList={(newState) => this.setState({ unRankedList: newState })}
                group={{ name: "shared-group-name", put: true}}
                sort={false}
                animation={150}
            >
                {unRankedList.map((item, index) => (
                    <div className="_RankedListItem" id={`simple-item-${item.response}`} key={item.key}>
                        {/* <span className="_RankedListIndex">{index + 1}.</span> */}
                        <span>{item.responseDescription}</span>
                    </div>
                ))}
            </ReactSortable>
        </Col>
        <Col md="6">
            <ReactSortable
                className="_UnRanked"
                id={`_Ranked_${configuration.key}`}
                list={rankedList}
                setList={(props) => this.handleResponse(props)}
                group="shared-group-name"
                // onChange={() => this.handleRankItem()}
                animation={150}
            >
                {rankedList !== undefined && rankedList.map((item, index) => (
                    <div className="_UnRankedListItem" id={`simple-item-${item.response}`} key={item.key}>
                        <span className="_RankedListIndex">{index + 1}.</span>
                        <span>{item.responseDescription}</span>
                        <span id={`simple-item-${item.response}`} key={item.response} className="_UnRankedListRemovedIcon" onClick={(id)=> this.removeItem(item.response)}>
                            <i className="fa fa-close"></i>
                        </span>
                    </div>
                ))}
            </ReactSortable>
            {configuration.scalePostSection !== null ? <div dangerouslySetInnerHTML={{__html:processResponse(configuration.scalePostSection)}}></div>:null}
        </Col></>:
        <Col md="12">
            <ReactSortable
                className={`_Ranked`}
                list={simpleRankList}
                setList={(newState) => this.handleSimpleList(newState)}
                onChange={() => this.handleDrag()}
                animation={150}
            >
                {simpleRankList.map((item, index) => (
                    <div className="_RankedListItem" id={`simple-item-${item.response}`} key={item.key}>
                        <span className="_RankedListIndex">{this.state.isSelect !== true ? "-" : index + 1}</span>
                        <span>{item.responseDescription}</span>
                    </div>
                ))}
            </ReactSortable>
        </Col>}
      </Row>
    </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
    answeredQuestionCount:state.survey.answeredQuestionCount,
    getAllItemResponse:state.survey.getAllItemResponse,
    getAllItemResponseForMultiple:state.survey.getAllItemResponseForMultiple
})

export default connect(mapStateToProps)(RankItemGroupResponse);
